module.exports = __webpack_public_path__ + "static/media/user-name-tag-empty.d698d39e.svg";